export default "__VITE_ASSET__CIFUTn7X__"